import { toast } from 'react-hot-toast'

export interface PermissionError {
  status: number
  message: string
  requiredPermission?: string
  userRole?: string
}

export const handlePermissionError = (error: any, context?: string): boolean => {
  const status = error?.response?.status
  const errorMessage = error?.response?.data?.error || error?.message

  // Handle different types of permission errors
  switch (status) {
    case 401:
      // Authentication error - token invalid or expired
      toast.error('Your session has expired. Please log in again.', {
        duration: 5000,
        icon: '🔐'
      })
      return true

    case 403:
      // Permission denied - user doesn't have required permissions
      const permissionMessage = getPermissionErrorMessage(errorMessage, context)
      toast.error(permissionMessage, {
        duration: 6000,
        icon: '🚫'
      })
      return true

    case 404:
      // Resource not found
      toast.error('The requested resource was not found.', {
        duration: 4000,
        icon: '🔍'
      })
      return true

    case 500:
      // Server error
      toast.error('A server error occurred. Please try again later.', {
        duration: 5000,
        icon: '⚠️'
      })
      return true

    default:
      // Generic error
      toast.error(errorMessage || 'An unexpected error occurred.', {
        duration: 4000,
        icon: '❌'
      })
      return false
  }
}

const getPermissionErrorMessage = (errorMessage: string, context?: string): string => {
  // Check if it's a specific permission error
  if (errorMessage?.includes('permission') || errorMessage?.includes('access denied')) {
    return `Access denied. You don't have permission to ${context || 'access this feature'}.`
  }

  // Check if it's a role-based error
  if (errorMessage?.includes('role') || errorMessage?.includes('administrator')) {
    return 'This feature is only available to staff members.'
  }

  // Check if it's a services-specific error
  if (errorMessage?.includes('services') || context?.includes('service')) {
    return 'You don\'t have permission to view services. Please contact your administrator.'
  }

  // Generic permission error
  return 'Access denied. You don\'t have the required permissions for this action.'
}

export const showPermissionRequiredMessage = (feature: string, requiredRole?: string) => {
  const roleMessage = requiredRole ? ` (${requiredRole} only)` : ''
  toast.error(`Access denied. ${feature} is restricted to authorized users${roleMessage}.`, {
    duration: 6000,
    icon: '🚫'
  })
}

export const showFeatureUnavailableMessage = (feature: string, reason?: string) => {
  const reasonMessage = reason ? ` ${reason}` : ''
  toast.error(`${feature} is currently unavailable${reasonMessage}.`, {
    duration: 5000,
    icon: '⚠️'
  })
}






